<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="geo-section geo-section--transfer" v-if="isLoad">
            <div class="page-title">
              <h2>Setting & Data | Transfer Prices</h2>
            </div>
            <form>
              <div class="geo-section__add  geo-section__add-add-transfer">
                <div class="section-title">
                  <h3>Transfer Prices</h3>
                  <div class="currency-label"><span>USD</span></div>
                </div>
                <form action="javascript:void(0)" class="geo-section__transfer-form">
                  <div :class="['form-control-group form-control-wrap', {'is-error' : errors.departure}]"><span
                    class="form-control-label">Departure</span>
                    <div :class="['select-wrapper', {'is-active': selects.departure}]"
                         @click="changeSelects('departure');errors.departure = false;errors.arrival = false"
                    >
                      <div class="select-trigger">
                        <span
                          ref="departureSelectInput"
                          contenteditable="true"
                          @input="checkSelectEdit($event)"
                          class="select-trigger__name">{{ selectsActive.departure.title || 'Choose' }}</span>
                        <span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div v-for="point in filteredPoints" :key="point.id"
                               :class="['select-option', {'is-selected': point.title === selectsActive.departure.title }]"
                               @click="selectsActive.departure = point; $refs.departureSelectInput.textContent = selectsActive.departure.title"><span
                            class="select-option__name">{{ point.title }}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group-divider">
                    <svg width="1em" height="1em" class="icon icon-chevron-double ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron-double"></use>
                    </svg>
                  </div>
                  <div :class="['form-control-group form-control-wrap', {'is-error' : errors.arrival}]"><span
                    class="form-control-label">Arrival</span>
                    <div :class="['select-wrapper', {'is-active': selects.arrival}]"
                         @click="changeSelects('arrival');errors.arrival = false;errors.departure = false">
                      <div class="select-trigger"><span
                        class="select-trigger__name"
                        ref="arrivalSelectInput"
                        contenteditable="true"
                        @input="checkSelectEdit($event)"
                      >
                        {{ selectsActive.arrival.title || 'Choose' }}</span><span
                        class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div v-for="point in filteredPoints" :key="point.id"
                               :class="['select-option', {'is-selected': point.title === selectsActive.arrival.title }]"
                               @click="selectsActive.arrival = point; $refs.arrivalSelectInput.textContent = selectsActive.departure.title"><span
                            class="select-option__name">{{ point.title }}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group--double">
                    <div :class="['form-control-wrap', {'is-error' : errors.duration}]" :style="{width: '60px'}">
                      <span class="form-control-label">Duration</span>
                      <input type="number" Placeholder="0" v-model="duration" @focus="errors.duration = false"
                             class="form-control"/>
                    </div>
                    <div class="form-control-wrap" :style="{width: '90px'}">
                      <span class="form-control-label">Price for</span>
                      <div :class="['select-wrapper', 'select-wrapper--xs', {'is-active': selects.pax}]"
                           @click="changeSelects('pax')">
                        <div class="select-trigger"><span
                          class="select-trigger__name">{{ selectsActive.pax }}</span><span class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner">
                            <div :class="['select-option', {'is-selected': selectsActive.pax === 'USD' }]"
                                 @click="selectsActive.pax = 'USD'"><span class="select-option__name">USD</span></div>
                            <div :class="['select-option', {'is-selected': selectsActive.pax === 'TZS' }]"
                                 @click="selectsActive.pax = 'TZS'"><span class="select-option__name">TZS</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :class="['form-control-wrap', {'is-error' : errors.pax1}]" :style="{width: '60px'}">
                      <span class="form-control-label">1-3 Pax</span>
                      <input type="number" Placeholder="0" v-model="amount1" @focus="errors.pax1 = false"
                             class="form-control"/>
                    </div>
                    <div :class="['form-control-wrap', {'is-error' : errors.pax4}]" :style="{width: '60px'}">
                      <span class="form-control-label">4-6 Pax</span>
                      <input type="number" Placeholder="0" v-model="amount4" @focus="errors.pax4 = false"
                             class="form-control"/>
                    </div>
                    <div :class="['form-control-wrap', {'is-error' : errors.pax7}]" :style="{width: '60px'}">
                      <span class="form-control-label">7-10 Pax</span>
                      <input type="number" Placeholder="0" v-model="amount7" @focus="errors.pax7 = false"
                             class="form-control"/>
                    </div>
                  </div>
                  <button type="submit" class="btn btn--green geo-section__transfer-form__submit"
                          @click="createPriceHandler"><span>Add</span></button>
                </form>
              </div>
            </form>
            <div class="geo-section__transfer">
              <div class="section-title">
                <h3 :style="{textTransform: 'none'}">Transfers (18% VAT included)</h3>
                <div class="currency-label"><span>USD</span></div>
                <div class="form-control-wrap">
                  <input type="text" placeholder="Search" v-model="search" class="form-control-search"/>
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div data-simplebar="data-simplebar" class="section-table-wrap">
                <div class="section-table section-table--geo">
                  <div class="section-table__head">
                    <div class="col col-departure"><span>Departure</span></div>
                    <div class="col col-arrival"><span>Arrival</span></div>
                    <div class="col col-arrival" :style="{width: '9rem'}"><span>Duration</span></div>
                    <div class="col col-price"><span>Price for 1-3 Pax</span></div>
                    <div class="col col-price"><span>Price for 4-6 Pax</span></div>
                    <div class="col col-price"><span>Price for 7-10 Pax</span></div>
                  </div>
                  <div class="section-table__body">
                    <div class="section-table__row"
                         v-for="item in filteredTransfers.slice((page - 1) * 15, ((page - 1) * 15) + 15)"
                         :key="item.id">
                      <div class="col col-departure">
                        <div class="section-table__row__name">{{ item.departure }}</div>
                        <svg width="1em" height="1em" class="icon icon-chevron-double ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron-double"></use>
                        </svg>
                      </div>
                      <div class="col col-arrival"><span>{{ item.arrival }}</span></div>
                      <div class="col col-arrival" :style="{width: '9rem'}"><span>{{ item.duration }} min</span></div>
                      <div class="col col-price"><span>{{ item.pax1_3 }}</span></div>
                      <div class="col col-price"><span>{{ item.pax4_6 }}</span></div>
                      <div class="col col-price"><span>{{ item.pax7_10 }}</span></div>
                      <div class="col col-actions">
                        <button type="button" class="btn btn--edit" @click="editPrice(item.id)">
                          <svg width="1em" height="1em" class="icon icon-edit ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                        entity: 'Transfer',
                                        name: 'this',
                                        handler: deletePriceHandler,
                                        id: item.id
                                    })">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                :page="page"
                :pageCount="pageCount"
                @pageController="pageController"/>
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="edit">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--transfer" v-if="edit">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-edit ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                </svg>
              </div>
              <span>Edit transfer</span>
            </div>
            <div class="edit-popup__close" @click="isEdit ? $emit('notLeavePopupHandler', {
                                handler: clearEdit
                            }) : edit = null">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__side-group">
              <div class="edit-popup__side">
                <div :class="['form-control-group form-control-wrap', {'is-error' : errorsUpdate.departure}]"><span
                  class="form-control-label">Departure</span>
                  <div :class="['select-wrapper', {'is-active': selectsEdit.departure}]"
                       @click="changeSelectsEdit('departure');errorsUpdate.departure = false">
                    <div class="select-trigger"><span
                      contenteditable="true"
                      @input="checkSelectEdit($event)"
                      ref="departureSelectEditInput"
                      class="select-trigger__name">{{
                        points.find(item => item.id === edit.departure).title || 'Choose'
                      }}</span><span
                      class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div v-for="point in filteredPoints" :key="point.id"
                             :class="['select-option', {'is-selected': point.id === edit.departure }]"
                             @click="edit.departure = point.id;isEdit = true;$refs.departureSelectEditInput.textContent = point.title"><span
                          class="select-option__name">{{ point.title }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-control-group-divider">
                <svg width="1em" height="1em" class="icon icon-chevron-double ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron-double"></use>
                </svg>
              </div>
              <div class="edit-popup__side">
                <div :class="['form-control-group form-control-wrap', {'is-error' : errorsUpdate.arrival}]"><span
                  class="form-control-label">Arrival</span>
                  <div :class="['select-wrapper', {'is-active': selectsEdit.arrival}]"
                       @click="changeSelectsEdit('arrival');errorsUpdate.arrival = false">
                    <div class="select-trigger"><span
                      contenteditable="true"
                      @input="checkSelectEdit($event)"
                      ref="arrivalSelectEditInput"
                      class="select-trigger__name">{{
                        points.find(item => item.id === edit.arrival).title || 'Choose'
                      }}</span><span
                      class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div v-for="point in filteredPoints" :key="point.id"
                             :class="['select-option', {'is-selected': point.id === edit.arrival }]"
                             @click="edit.arrival = point.id;isEdit = true;$refs.arrivalSelectEditInput.textContent = point.title"><span
                          class="select-option__name">{{ point.title }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div :class="['form-control-wrap', {'is-error' : errorsUpdate.duration}]" :style="{width: '60px'}">
                <span class="form-control-label">Duration</span>
                <input type="number" Placeholder="0" @change="isEdit = true" v-model="edit.duration"
                       class="form-control"/>
              </div>
              <div class="form-control-group form-control-group--double">
                <div class="form-control-wrap" :style="{width: '90px'}">
                                    <span class="form-control-label">Price
                                    for</span>
                  <div :class="['select-wrapper', 'select-wrapper--xs', {'is-active': selectsEdit.pax}]"
                       @click="changeSelectsEdit('pax')">
                    <div class="select-trigger"><span class="select-trigger__name">{{ edit.currencyType }}</span><span
                      class="select-trigger__icon">
                                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                            <use
                                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                            </svg></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div :class="['select-option', {'is-selected': edit.currencyType === 'USD' }]"
                             @click="edit.currencyType = 'USD';isEdit = true"><span
                          class="select-option__name">USD</span></div>
                        <div :class="['select-option', {'is-selected': edit.currencyType === 'TZS' }]"
                             @click="edit.currencyType = 'TZS';isEdit = true"><span
                          class="select-option__name">TZS</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="['form-control-wrap', {'is-error' : errorsUpdate.pax1}]" :style="{width: '60px'}">
                  <span class="form-control-label">1-3 Pax</span>
                  <input type="number" Placeholder="0" @change="isEdit = true" v-model="edit.pax1_3"
                         class="form-control"/>
                </div>
                <div :class="['form-control-wrap', {'is-error' : errorsUpdate.pax4}]" :style="{width: '60px'}">
                  <span class="form-control-label">4-6 Pax</span>
                  <input type="number" Placeholder="0" @change="isEdit = true" v-model="edit.pax4_6"
                         class="form-control"/>
                </div>
                <div :class="['form-control-wrap', {'is-error' : errorsUpdate.pax7}]" :style="{width: '60px'}">
                  <span class="form-control-label">7-10 Pax</span>
                  <input type="number" Placeholder="0" @change="isEdit = true" v-model="edit.pax7_10"
                         class="form-control"/>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <button type="submit" class="btn btn--green edit-popup__submit" @click="savePriceHandler">
                <span>Save</span></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {createPrice, deletePrice, getPointsAll, getPrice, getPricesAll, updatePrice} from '@/utilites/api'

import Pagination from '@/components/Pagination'

export default {
  props: ['user'],
  components: {Pagination},
  data() {
    return {
      pricesData: [],
      prices: [],
      points: [],
      selects: {
        departure: false,
        arrival: false,
        pax: false
      },
      selectsActive: {
        departure: {
          title: ''
        },
        arrival: {
          title: ''
        },
        pax: 'USD'
      },
      selectsEdit: {
        departure: false,
        arrival: false,
        pax: false
      },
      amount1: '',
      amount4: '',
      amount7: '',
      duration: '',
      page: 1,
      pageCount: 0,
      search: '',
      edit: null,
      isLoad: false,
      errors: {
        departure: false,
        arrival: false,
        pax1: false,
        pax4: false,
        pax7: false,
        duration: false
      },
      errorsUpdate: {
        departure: false,
        arrival: false,
        pax1: false,
        pax4: false,
        pax7: false,
        duration: false
      },
      isEdit: false,
      selectInputSearch: '',
    }
  },
  beforeCreate() {
    document.title = 'Setting & Data / Transfer Prices'
  },
  mounted() {
    document.title = 'Setting & Data / Transfer Prices'
    this.updateData()
    getPointsAll(this.user.access_token)
      .then(res => {
        this.points = res.sort((a, b) => a.title < b.title ? -1 : 1)
      })
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          departure: false,
          arrival: false,
          pax: false
        }
        this.selectsEdit = {
          departure: false,
          arrival: false,
          pax: false
        }
      }
      if (!event.target.closest('.edit-popup') && !event.target.closest('.btn')) {
        if (this.isEdit) {
          this.$emit('notLeavePopupHandler', {
            handler: this.clearEdit
          })
        } else {
          this.edit = false
        }
      }
    })
  },
  methods: {
    checkSelectEdit(e) {
      this.selectInputSearch = e.target.textContent
    },
    changeSelects(target) {
      this.selects = {
        departure: false,
        arrival: false,
        pax: false,
        [target]: !this.selects[target]
      }
      this.selectInputSearch = ''
      if(target === 'departure' && this.selects.departure) {
        this.$refs.departureSelectInput.focus()
        if (!this.selectsActive.departure.title) this.$refs.departureSelectInput.textContent = ''
      } else {
        this.$refs.departureSelectInput.blur()
      }
      if(target === 'arrival' && this.selects.arrival) {
        this.$refs.arrivalSelectInput.focus()
        if (!this.selectsActive.arrival.title) this.$refs.arrivalSelectInput.textContent = ''
      } else {
        this.$refs.arrivalSelectInput.blur()
      }
    },
    changeSelectsEdit(target) {
      this.selectsEdit = {
        departure: false,
        arrival: false,
        pax: false,
        [target]: !this.selectsEdit[target]
      }
      this.selectInputSearch = ''
      if(target === 'departure' && this.selectsEdit.departure) {
        this.$refs.departureSelectEditInput.focus()
      } else {
        this.$refs.departureSelectEditInput.blur()
      }
      if(target === 'arrival' && this.selectsEdit.arrival) {
        this.$refs.arrivalSelectEditInput.focus()
      } else {
        this.$refs.arrivalSelectEditInput.blur()
      }
    },
    checkErrors() {
      this.errors = {
        departure: this.selectsActive.departure.id ? false : true,
        arrival: this.selectsActive.arrival.id ? false : true,
        pax1: +this.amount1 ? false : true,
        pax4: +this.amount4 ? false : true,
        pax7: +this.amount7 ? false : true,
        duration: +this.duration && +this.duration > 0 ? false : true,
      }
      if (this.prices.find(item => {
        return (item.departure === this.selectsActive.departure.title && item.arrival === this.selectsActive.arrival.title) || (item.departure === this.selectsActive.arrival.title && item.arrival === this.selectsActive.departure.title)
      })) {
        this.errors = {
          ...this.errors,
          departure: true,
          arrival: true
        }
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      return error
    },
    checkErrorsUpdate() {
      this.errorsUpdate = {
        departure: false,
        arrival: false,
        pax1: +this.edit.pax1_3 ? false : true,
        pax4: +this.edit.pax4_6 ? false : true,
        pax7: +this.edit.pax7_10 ? false : true,
        duration: +this.edit.duration && +this.edit.duration > 0 ? false : true,
      }
      let error = false
      for (const key in this.errorsUpdate) {
        if (this.errorsUpdate[key]) {
          error = true
        }
      }
      return error
    },
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.prices.length / 15)
    },
    deletePriceHandler(id) {
      deletePrice(this.user.access_token, id)
        .then(() => {
          this.updateData()
          this.$emit('confirmed')
        })
    },
    editPrice(item) {
      getPrice(this.user.access_token, item)
        .then(res => {
          this.edit = res
        })
    },
    savePriceHandler() {
      if (!this.checkErrorsUpdate()) {
        updatePrice(this.user.access_token, this.edit)
          .then(() => {
            this.updateData()
            this.edit = null
            this.$emit('confirmed')
            this.isEdit = false
          })
          .catch(() => {
            this.errorsUpdate.departure = true
            this.errorsUpdate.arrival = true
          })
      }
    },
    createPriceHandler() {
      if (!this.checkErrors()) {
        let data = {
          id: Date.now(),
          departure: this.selectsActive.departure.id,
          arrival: this.selectsActive.arrival.id,
          pax1_3: +this.amount1,
          pax4_6: +this.amount4,
          pax7_10: +this.amount7,
          duration: +this.duration,
          currency: this.selectsActive.pax,
        }
        createPrice(data)
          .then(res => {
            this.updateData()
            this.selectsActive = {
              departure: {
                title: ''
              },
              arrival: {
                title: ''
              },
              pax: 'USD'
            }
            this.amount1 = ''
            this.amount4 = ''
            this.amount7 = ''
            this.search = ''
            this.duration = ''
            this.$emit('confirmed')
          })
          .catch(() => {
            this.errors.departure = true
            this.errors.arrival = true
          })
      }
    },
    updateData() {
      this.isLoad = false
      getPricesAll(this.user.access_token)
        .then(res => {
          this.isLoad = true
          this.pricesData = res
          this.prices = res
        })
    },
    clearEdit() {
      this.edit = null
      this.isEdit = false
    },
  },
  watch: {
    prices() {
      this.pageCountHandler()
    },
    search() {
      if (this.search.length === 0) {
        this.prices = this.pricesData
      }
      this.page = 1
      let filtered = this.pricesData.filter(item => this.search.length ? ((item.departure && item.departure.toLowerCase().includes(this.search.toLowerCase())) || (item.arrival && item.arrival.toLowerCase().includes(this.search.toLowerCase()))) ? item : false : item)
      this.prices = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    },
    'selects.departure'(newVal) {
      if (!newVal && this.selectsActive.departure.title) this.$refs.departureSelectInput.textContent = this.selectsActive.departure.title
      if (!newVal && !this.selectsActive.departure.title) this.$refs.departureSelectInput.textContent = 'Choose'
    },
    'selects.arrival'(newVal) {
      if (!newVal && this.selectsActive.arrival.title) this.$refs.arrivalSelectInput.textContent = this.selectsActive.arrival.title
      if (!newVal && !this.selectsActive.arrival.title) this.$refs.arrivalSelectInput.textContent = 'Choose'
    },
    'selectsEdit.departure'(newVal) {
      if (!newVal && this.edit.departure) {
        this.$refs.departureSelectEditInput.textContent = this.points.find(point => point.id === this.edit.departure).title
      }
    },
    'selectsEdit.arrival'(newVal) {
      if (!newVal && this.edit.arrival) {
        this.$refs.arrivalSelectEditInput.textContent = this.points.find(point => point.id === this.edit.arrival).title
      }
    },
  },
  computed: {
    filteredTransfers() {
      let reversedTransfers = []
      this.prices.forEach(item => {
        let reverse = this.prices.find(transfer => transfer.id !== item.id && transfer.arrival === item.departure && transfer.departure === item.arrival)
        if (reverse && !reversedTransfers.includes(item.id)) {
          reversedTransfers.push(reverse.id)
        }
      })
      return this.prices.filter(item => !reversedTransfers.includes(item.id))
    },
    filteredPoints() {
      return this.points.filter(point => point.title.toLowerCase().includes(this.selectInputSearch.toLowerCase()))
    }
  }
}
</script>
